import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

const OVERLAY_SX = {
  position: 'absolute',
  inset: 0,
  zIndex: 2,
  gap: 2,
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  backdropFilter: 'blur(3px)',
  bgcolor: 'rgba(255, 255, 255, 0.55)',
};

export function RescoringOverlay(): ReactNode {
  return (
    <Stack sx={OVERLAY_SX} data-testid="rescoring-overlay">
      <CircularProgress size={44} thickness={4} />
      <Box>
        <Typography sx={{ fontSize: 17, fontWeight: 600 }}>
          Re-scoring creatives
          <br />
          by your new selections…
        </Typography>
        <Typography sx={{ mt: 1, fontSize: 14, color: 'text.muted' }}>
          Just a few seconds.
        </Typography>
      </Box>
    </Stack>
  );
}
